// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const beedrill: PokeData = {
  "id": 15,
  "name": "beedrill",
  "height": 10,
  "weight": 295,
  "base_experience": 178,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "fury-attack",
    "poison-sting",
    "twineedle",
    "pin-missile",
    "peck",
    "string-shot",
    "agility",
    "rage",
    "harden",
    "focus-energy",
    "outrage",
    "fury-cutter",
    "pursuit",
    "endeavor",
    "assurance",
    "toxic-spikes",
    "poison-jab",
    "bug-bite",
    "venoshock",
    "fell-stinger",
    "laser-focus"
  ],
  "moves": [
    "pin-missile",
    "peck",
    "string-shot",
    "outrage",
    "pursuit",
    "toxic-spikes",
    "poison-jab",
    "bug-bite",
    "venom-drench",
    "sludge-bomb",
    "acid",
    "signal-spam",
    "bug-buzz"
  ],
  "evolution_chain": {
    "id": 5,
    "item": null,
    "species": [
      {
        "name": "weedle",
        "order": 13,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kakuna",
        "order": 14,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 13,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "beedrill",
        "order": 15,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 14,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 132,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
